import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FALLBACK_IMAGES } from "@/data/homeData";

export function DiscoveryCTA() {
  return (
    <section className="relative py-24 overflow-hidden" data-testid="discovery-section">
      <div className="absolute inset-0">
        <img src={FALLBACK_IMAGES[1]} alt="Logement" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#2C1E14]/85" />
      </div>
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
          <h2 className="text-3xl md:text-4xl text-white mb-6">
            Nos logements d'exception à Limoges et Évaux-les-Bains
          </h2>
          <p className="text-white/80 mb-4 leading-relaxed max-w-2xl mx-auto">
            Chaque logement est pensé et équipé pour offrir une expérience premium : cuisine tout équipée, 
            literie haut de gamme, connexion haut débit, TV connectée.
          </p>
          <p className="text-white/70 mb-8 max-w-2xl mx-auto">
            Que vous fasciez escale pour une nuit d'affaires ou que vous posiez vos valises 
            pour un séjour de ressourcement, chaque espace a été dessiné pour devenir le vôtre.
          </p>
          <Link to="/voyageurs" className="btn-light inline-flex items-center gap-2.5" data-testid="discovery-cta">
            Réservez mon séjour
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
